export const destinations = [
  {
    slug: "maquoketa-caves",
    title: "Maquoketa Caves State Park",
    region: "Midwest",
    country: "USA",

    thumbnailImage:
      "https://images.pexels.com/photos/2325447/pexels-photo-2325447.jpeg",

    heroImage:
      "https://images.pexels.com/photos/2325447/pexels-photo-2325447.jpeg",

    description:
      "Explore caves, rugged trails, and dramatic rock formations in eastern Iowa.",

    highlights: ["Dancehall Cave", "Hiking Trails", "Camping", "Photography"],

    mapEmbed:
      "https://www.google.com/maps?q=Maquoketa+Caves+State+Park&output=embed",

    guides: [
      { title: "Best Trails Guide", link: "/guides/maquoketa-trails" },
      { title: "Photography Tips", link: "/guides/cave-photography" },
    ],

    videos: [
      { title: "Mini Miles Adventure", link: "/watch/maquoketa-adventure" },
    ],
  },

  {
    slug: "maquoketa-caves-bluffs",
    title: "Maquoketa Caves State Park",
    region: "Midwest",
    country: "USA",

    thumbnailImage:
      "https://images.unsplash.com/photo-1465146344425-f00d5f5c8f07?q=80&w=2376&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",

    heroImage:
      "https://images.unsplash.com/photo-1465146344425-f00d5f5c8f07?q=80&w=2376&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",

    description:
      "Explore caves, rugged trails, and dramatic rock formations in eastern Iowa.",

    highlights: ["Dancehall Cave", "Hiking Trails", "Camping", "Photography"],

    mapEmbed:
      "https://www.google.com/maps?q=Maquoketa+Caves+State+Park&output=embed",

    guides: [
      { title: "Best Trails Guide", link: "/guides/maquoketa-trails" },
      { title: "Photography Tips", link: "/guides/cave-photography" },
    ],

    videos: [
      { title: "Mini Miles Adventure", link: "/watch/maquoketa-adventure" },
    ],
  },

  {
    slug: "maquoketa-caves-trails",
    title: "Maquoketa Caves State Park",
    region: "Midwest",
    country: "USA",

    thumbnailImage:
      "https://images.unsplash.com/photo-1470071459604-3b5ec3a7fe05?q=80&w=2774&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",

    heroImage:
      "https://images.unsplash.com/photo-1470071459604-3b5ec3a7fe05?q=80&w=2774&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",

    description:
      "Explore caves, rugged trails, and dramatic rock formations in eastern Iowa.",

    highlights: ["Dancehall Cave", "Hiking Trails", "Camping", "Photography"],

    mapEmbed:
      "https://www.google.com/maps?q=Maquoketa+Caves+State+Park&output=embed",

    guides: [
      { title: "Best Trails Guide", link: "/guides/maquoketa-trails" },
      { title: "Photography Tips", link: "/guides/cave-photography" },
    ],

    videos: [
      { title: "Mini Miles Adventure", link: "/watch/maquoketa-adventure" },
    ],
  },

  {
    slug: "maquoketa-caves-trailsTwo",
    title: "Maquoketa Caves State Park",
    region: "Midwest",
    country: "USA",

    thumbnailImage:
      "https://images.unsplash.com/photo-1421789665209-c9b2a435e3dc?q=80&w=2371&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",

    heroImage:
      "https://images.unsplash.com/photo-1421789665209-c9b2a435e3dc?q=80&w=2371&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",

    description:
      "Explore caves, rugged trails, and dramatic rock formations in eastern Iowa.",

    highlights: ["Dancehall Cave", "Hiking Trails", "Camping", "Photography"],

    mapEmbed:
      "https://www.google.com/maps?q=Maquoketa+Caves+State+Park&output=embed",

    guides: [
      { title: "Best Trails Guide", link: "/guides/maquoketa-trails" },
      { title: "Photography Tips", link: "/guides/cave-photography" },
    ],

    videos: [
      { title: "Mini Miles Adventure", link: "/watch/maquoketa-adventure" },
    ],
  },

  {
    slug: "maquoketa-caves-trailsThree",
    title: "Maquoketa Caves State Park",
    region: "Midwest",
    country: "USA",

    thumbnailImage:
      "https://images.unsplash.com/photo-1426604966848-d7adac402bff?q=80&w=2370&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",

    heroImage:
      "https://images.unsplash.com/photo-1426604966848-d7adac402bff?q=80&w=2370&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",

    description:
      "Explore caves, rugged trails, and dramatic rock formations in eastern Iowa.",

    highlights: ["Dancehall Cave", "Hiking Trails", "Camping", "Photography"],

    mapEmbed:
      "https://www.google.com/maps?q=Maquoketa+Caves+State+Park&output=embed",

    guides: [
      { title: "Best Trails Guide", link: "/guides/maquoketa-trails" },
      { title: "Photography Tips", link: "/guides/cave-photography" },
    ],

    videos: [
      { title: "Mini Miles Adventure", link: "/watch/maquoketa-adventure" },
    ],
  },

  {
    slug: "maquoketa-caves-trailsFour",
    title: "Maquoketa Caves State Park",
    region: "Midwest",
    country: "USA",

    thumbnailImage:
      "https://plus.unsplash.com/premium_photo-1719943510748-4b4354fbcf56?q=80&w=2370&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",

    heroImage:
      "https://plus.unsplash.com/premium_photo-1719943510748-4b4354fbcf56?q=80&w=2370&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",

    description:
      "Explore caves, rugged trails, and dramatic rock formations in eastern Iowa.",

    highlights: ["Dancehall Cave", "Hiking Trails", "Camping", "Photography"],

    mapEmbed:
      "https://www.google.com/maps?q=Maquoketa+Caves+State+Park&output=embed",

    guides: [
      { title: "Best Trails Guide", link: "/guides/maquoketa-trails" },
      { title: "Photography Tips", link: "/guides/cave-photography" },
    ],

    videos: [
      { title: "Mini Miles Adventure", link: "/watch/maquoketa-adventure" },
    ],
  },

  {
    slug: "maquoketa-caves-trailsFive",
    title: "Maquoketa Caves State Park",
    region: "Midwest",
    country: "USA",

    thumbnailImage:
      "https://plus.unsplash.com/premium_photo-1719943510748-4b4354fbcf56?q=80&w=2370&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",

    heroImage:
      "https://plus.unsplash.com/premium_photo-1719943510748-4b4354fbcf56?q=80&w=2370&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",

    description:
      "Explore caves, rugged trails, and dramatic rock formations in eastern Iowa.",

    highlights: ["Dancehall Cave", "Hiking Trails", "Camping", "Photography"],

    mapEmbed:
      "https://www.google.com/maps?q=Maquoketa+Caves+State+Park&output=embed",

    guides: [
      { title: "Best Trails Guide", link: "/guides/maquoketa-trails" },
      { title: "Photography Tips", link: "/guides/cave-photography" },
    ],

    videos: [
      { title: "Mini Miles Adventure", link: "/watch/maquoketa-adventure" },
    ],
  },

  {
    slug: "maquoketa-caves-trailsSix",
    title: "Maquoketa Caves State Park",
    region: "Midwest",
    country: "USA",

    thumbnailImage:
      "https://plus.unsplash.com/premium_photo-1719943510748-4b4354fbcf56?q=80&w=2370&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",

    heroImage:
      "https://plus.unsplash.com/premium_photo-1719943510748-4b4354fbcf56?q=80&w=2370&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",

    description:
      "Explore caves, rugged trails, and dramatic rock formations in eastern Iowa.",

    highlights: ["Dancehall Cave", "Hiking Trails", "Camping", "Photography"],

    mapEmbed:
      "https://www.google.com/maps?q=Maquoketa+Caves+State+Park&output=embed",

    guides: [
      { title: "Best Trails Guide", link: "/guides/maquoketa-trails" },
      { title: "Photography Tips", link: "/guides/cave-photography" },
    ],

    videos: [
      { title: "Mini Miles Adventure", link: "/watch/maquoketa-adventure" },
    ],
  },
];
